var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14.764,
    viewBox: "0 0 17 14.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.047,47.089H14.693a.618.618,0,1,1,0-1.2H25.047a.618.618,0,1,1,0,1.2Z",
    transform: "translate(-9.819 -33.483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.047,28.258H14.693a.618.618,0,1,1,0-1.2H25.047a.618.618,0,1,1,0,1.2Z",
    transform: "translate(-9.819 -20.778)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.047,9.427H14.693a.7.7,0,0,1-.773-.6.7.7,0,0,1,.773-.6H25.047a.7.7,0,0,1,.773.6A.7.7,0,0,1,25.047,9.427Z",
    transform: "translate(-9.819 -8.072)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.803,
    cy: 0.803,
    r: 0.803,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.803,
    cy: 0.803,
    r: 0.803,
    transform: "translate(0 6.079)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.803,
    cy: 0.803,
    r: 0.803,
    transform: "translate(0 12.158)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.ac47d191.svg";
export { ForwardRef as ReactComponent };